import NodeType from 'common/builder/constants/BackendContentType'

const hasNodesOfType = (flow, nodeType) => {
  return !!flow.contents.find((node) => node.type === nodeType)
}

export const hasFBNodes = (flow) => hasNodesOfType(flow, NodeType.DEFAULT)

export const hasSMSNodes = (flow) => hasNodesOfType(flow, NodeType.SMS)

export const hasEmailNodes = (flow) => hasNodesOfType(flow, NodeType.EMAIL_NEW)
